// Brand tokens shared by the app theme (theme.js) and the landing page (landingTheme.js), so the
// public page and the signed-in screens read as one product. The landing page uses them at display
// scale; the app uses them at working density.
export const brand = {
    ink: '#0B1220',
    inkMuted: '#4B5565',
    line: 'rgba(11, 18, 32, 0.08)',
    lineStrong: 'rgba(11, 18, 32, 0.14)',
    paper: '#FFFFFF',
    subtle: '#F5F7FC',
    accent: '#1E3A5F',
    accentHover: '#162C49',
    accentMid: '#3A5A85',
    accentDeep: '#132840',
    accentTint: '#E8EEF6',
    highlight: '#F59E6C',
    highlightTint: '#FFF1E8',
    display: '"Plus Jakarta Sans", "Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
    body: '"Inter", system-ui, -apple-system, "Segoe UI", sans-serif',
    ease: 'cubic-bezier(0.22, 1, 0.36, 1)',
};
